(function(){
'use strict';
const $=(s,c=document)=>c.querySelector(s);
const $$=(s,c=document)=>[...c.querySelectorAll(s)];
const on=(el,ev,fn)=>el&&el.addEventListener(ev,fn);
const isPage=(...t)=>t.some(p=>document.body.classList.contains('template-'+p));

function initTrustBadges(){
  if(!isPage('product'))return;
  const atcBtn=$('.product-form__submit');
  if(!atcBtn||$('.ma-trust'))return;
  const wrap=document.createElement('div');
  wrap.className='ma-trust';
  wrap.innerHTML=`<div class="ma-trust-item"><span class="ma-trust-icon">🔒</span><span>Paiement sécurisé</span></div><div class="ma-trust-item"><span class="ma-trust-icon">🚚</span><span>Livraison mondiale</span></div><div class="ma-trust-item"><span class="ma-trust-icon">↩</span><span>Retours 14j</span></div>`;
  const parent=atcBtn.closest('form,.cart-functions,.product-actions')||atcBtn.parentElement;
  parent?.insertAdjacentElement('afterend',wrap);
}

function initCartUpsell(){
  const cartBody=$('#site-cart .site-nav-container-last,.cart-form');
  if(!cartBody||$('.ma-upsell'))return;
  fetch('/products/casquette-highschool.js').then(r=>r.json()).then(product=>{
    const price=(product.price/100).toFixed(2).replace('.',',');
    const img=product.featured_image||'';
    const variant=product.variants?.[0]?.id;
    fetch('/cart.js').then(r=>r.json()).then(cart=>{
      const alreadyIn=cart.items?.some(i=>i.product_id===product.id);
      if(alreadyIn)return;
      const box=document.createElement('div');
      box.className='ma-upsell';
      box.innerHTML=`<div class="ma-upsell-label">Il manque juste ça</div><div class="ma-upsell-row"><div class="ma-upsell-img">${img?`<img src="${img}" alt="${product.title}">`:''}  </div><div class="ma-upsell-info"><div class="ma-upsell-name">${product.title}</div><div class="ma-upsell-price">${price} €</div></div><button class="ma-upsell-btn" data-variant="${variant}">+ Ajouter</button></div>`;
      cartBody.appendChild(box);
      on(box.querySelector('.ma-upsell-btn'),'click',async function(){
        try{
          await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(this.dataset.variant),quantity:1})});
          this.textContent='✓ Ajouté';
          this.style.background='#1a5c1a';
          box.style.opacity='.5';
          setTimeout(()=>box.remove(),2000);
        }catch(e){this.textContent='Réessayer';}
      });
    });
  }).catch(()=>{});
}

function initAnnouncementBar(){
  const bar=$('.announcement-bar__message,.announcement-bar [class*="title"],.announcement-bar p');
  if(!bar)return;
  const dropDate=new Date('2026-07-12T18:00:00');
  const now=new Date();
  if(now>=dropDate)return;
  const diff=dropDate-now;
  const days=Math.floor(diff/86400000);
  const hours=Math.floor((diff%86400000)/3600000);
  if(!bar.querySelector('.ma-bar-timer')){
    const timer=document.createElement('span');
    timer.className='ma-bar-timer';
    timer.textContent=` — J-${days} ${hours}h`;
    bar.appendChild(timer);
  }
}

function init(){
  initTrustBadges();
  initAnnouncementBar();
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-js-site-cart-sidebar],[href="/cart"]')){
      setTimeout(()=>{initCartUpsell();},800);
    }
  });
}

if(document.readyState!=='loading')init();
else document.addEventListener('DOMContentLoaded',init);
})();